<template>
  <div>
    <v-btn
      class="mb-4"
      v-for="(button, index) in buttons"
      :key="index"
      color="cardSurface"
      large
      block
      :to="{ name: button.to }"
      @click="$emit(button.emit)"
    >
      <v-icon left>{{ button.icon }}</v-icon>
      {{ button.title }}
      <v-badge
        v-if="button.content"
        color="primary"
        inline
        :content="button.content"
      ></v-badge>
      <v-icon class="ml-auto" right>mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { ButtonGroupObject } from "@/types/interface";

export default Vue.extend({
  name: "ProjectButtonShortcuts",
  props: {
    psiAccepted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttons(): Array<ButtonGroupObject> {
      var buttons = [
        {
          title: "Kontakter",
          icon: "mdi-account-group-outline",
        },
        {
          title: "Dokumenter",
          icon: "mdi-file-document-outline",
          to: "ProjectDocuments",
        },
        {
          title: "HMS Plan",
          icon: "mdi-account-hard-hat",
          to: "ProjectHms",
        },
        {
          title: "Møtereferater",
          icon: "mdi-script-text-outline",
          to: "ProjectMinutes",
        },
        {
          title: "Tidplan",
          icon: "mdi-chart-timeline",
        },
        {
          title: "Tegninger bygg",
          icon: "mdi-floor-plan",
        },
        {
          title: "Tilvalgsliste",
          icon: "mdi-package-variant",
        },
      ] as Array<ButtonGroupObject>;

      if (!this.psiAccepted) {
        buttons.push({
          title: "Sikkerhetsinnstruks",
          icon: "mdi-account-hard-hat",
          content: "!",
          emit: "psi",
        });
      }

      return buttons;
    },
  },
});
</script>
